module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/redux-act-async/~/core-js/library/modules/_library.js
// module id = 2007
// module chunks = 0